// src/analytics/useTrackPageView.ts
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {useMixpanelInstance} from './useMixpanelInstance';

export function useTrackPageView(options?: {auto?: boolean}) {
  const {auto = true} = options ?? {};
  const mp = useMixpanelInstance();
  const location = useLocation();

  useEffect(() => {
    mp.setPageContext(); // rafraîchit $current_url / $referrer
  }, [location.key, auto]);
}
